import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {NotificationData} from '../model/notification-data';
import {Localization} from '../../../../projects/common/src/lib/interface/localization.extension';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';

/** A notification that arrived while the app was open. */
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-notification-snackbar',
  template: `
    <div class="notif-snackbar">
      <app-notifications-list-item [notification]="notification" (handled)="ref.dismiss()"></app-notifications-list-item>
      <button mat-icon-button type="button" class="notif-snackbar__close"
              [attr.aria-label]="strings['close']" (click)="ref.dismiss()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  `,
  styles: [`
    .notif-snackbar {
      position: relative;
      width: min(400px, calc(100vw - 32px));
      min-width: min(300px, 100%);
    }
    .notif-snackbar app-notifications-list-item { display: block; padding-right: 32px; }
    .notif-snackbar__close {
      position: absolute; top: 4px; right: 4px;
      --mdc-icon-button-state-layer-size: 32px;
      width: 32px; height: 32px; padding: 4px;
      color: var(--text-muted);
    }
    .notif-snackbar__close .mat-icon { font-size: 18px; width: 18px; height: 18px; }
  `]
})
export class NotificationSnackbarComponent extends Localization {
  readonly notification = inject<NotificationData>(MAT_SNACK_BAR_DATA);
  readonly ref = inject<MatSnackBarRef<NotificationSnackbarComponent>>(MatSnackBarRef);
}
